module.exports = __webpack_public_path__ + "static/about-image-2-82a48e86716683ce83c0179a8b3f8fea.jpg";